import { LABOR_CODES_PATTERN } from "./constants";

export function validateFlowSettings({ flowName, laborCodes, resources = {} }) {
  const errors = [];

  if (!flowName || !flowName.trim()) {
    errors.push(resources["InvalidName"]);
  }

  if (laborCodes && !LABOR_CODES_PATTERN.test(laborCodes)) {
    errors.push(resources["InvalidLaborCodes"]);
  }

  return errors;
}
